import { compose, lifecycle, withState } from 'recompose'
import withType from 'components/common/hoc/withType'
import { generateItemListElement } from 'helpers/SEOSchema'
import BreadcrumbTwoColumns from './BreadcrumbTwoColumns'


const withBreadcrumbListSchema = withState('breadcrumbListSchema', 'setBreadcrumbListSchema', {})

const withBreadcrumbsLifecycle = lifecycle({
  componentDidMount() {
    const {
      links = [],
      setBreadcrumbListSchema
    } = this.props

    setBreadcrumbListSchema({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: generateItemListElement(links)
    })
  }
})

export default compose(
  withType({
    type: [
      'BOTBreadcrumbTwoColumnsLink',
      'BOTTireCompareBreadcrumbTwoColumnsLink',
      'BOTQuoteBreadcrumbTwoColumnsLink'
    ],
    placeholders: ['links', 'right']
  }),
  withBreadcrumbListSchema,
  withBreadcrumbsLifecycle
)(BreadcrumbTwoColumns)
